import { render, staticRenderFns } from "./FormDetail.vue?vue&type=template&id=01bea66e&scoped=true&"
import script from "./FormDetail.vue?vue&type=script&lang=ts&"
export * from "./FormDetail.vue?vue&type=script&lang=ts&"
import style0 from "./FormDetail.vue?vue&type=style&index=0&id=01bea66e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bea66e",
  null
  
)

export default component.exports